export default __webpack_public_path__ + "static/media/profile.133c51a9.gif";